import React, { useState } from 'react';
import styles from './FirstVisitPopup.module.css';

interface FirstVisitPopupProps {
    onClose: () => void;
}

export const FirstVisitPopup: React.FC<FirstVisitPopupProps> = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => {
        setIsVisible(false);
        onClose();
    };

    if (!isVisible) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <h3 className={styles.title}>Wybierz piętro, aby zobaczyć dostępne mieszkania</h3>
                </div>
                <div className={styles.body}>
                    <p>Kliknij w interesujące Cię piętro na rzucie budynku, a wyświetlą się szczegóły dostępnych mieszkań.</p>
                </div>
                <button 
                    className={styles.closeButton} 
                    onClick={handleClose}
                    aria-label="Zamknij"
                >
                    OK, rozumiem
                </button>
            </div>
        </div>
    );
};